<template>
  <el-table border :data="data">
    <el-table-column label="分类" align="center" width="200px" class-name="highlight-column">
      <template slot-scope="{ row }">
        <el-checkbox v-model="checkbox[row.name]" @change="permissionsChange($event, row)">{{ row.display_name }}</el-checkbox>
      </template>
    </el-table-column>
    <el-table-column label="一级分类" align="center" width="120px" class-name="highlight-column">
      <template slot-scope="{ row }" v-if="row?.children?.length > 0 && row.children[0]?.item_type != 99">
        <div class="last-bottom-none">
          <div v-for="(el) in row?.children" :key="el.id" _flex="~ items-center justify-center" class="border-bottom" :style="{ minHeight: cellHeight[el.name] + 'px' }">
            <el-checkbox v-model="checkbox[el.name]" @change="permissionsChange($event, el, row)">{{ el.display_name }}</el-checkbox>
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="二级分类（三级分类）" align="center">
      <template slot-scope="{ row }">
        <!-- 只有两层的情况 -->
        <div _flex="~ wrap" v-if="row?.children?.length > 0 &&row.children[0]?.item_type == 99" class="all">
          <div v-for="el in row?.children" :key="el.id" _m="l-15px" :style="{ width: ['电子教材', '目录', '课件'].includes(el.display_name) ? '100%' : '', textAlign: 'left' }">
            <el-checkbox v-model="checkbox[el.name]" @change="permissionsChange($event, el, row)">{{ el.display_name }}</el-checkbox>
            <div _flex="~ wrap">
              <div v-for="el2 in el?.children" :key="el2.id" _m="l-15px">
                <el-checkbox v-model="checkbox[el2.name]" @change="permissionsChange($event, el2, el)">{{ el2.display_name }}</el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <!-- 有多层的情况 -->
        <div v-else class="last-bottom-none">
          <div v-for="(child) in row?.children" :data-idx="child.name" :key="child.id" _flex="~ wrap" class="border-bottom all">
            <div
              v-for="childTwo in child?.children" :key="childTwo.id" _m="l-15px" :class="['nowrap']"
              :style="{
                width: (['能力点', '知识点'].includes(childTwo.display_name) || childTwo.item_type == 66) ? '100%' : '', textAlign: 'left'
              }"
            >
              <el-checkbox v-model="checkbox[childTwo.name]" @change="permissionsChange($event, childTwo, child)">{{ childTwo.display_name }}</el-checkbox>
              <div _flex="~ wrap" :class="[(['能力点', '知识点'].includes(childTwo.display_name) || childTwo.item_type == 66) && 'border-left-half']">
                <div v-for="childThree in childTwo?.children" :key="childThree.id" _m="l-15px"  _flex="~ wrap" :style="{
                  width: (childThree.item_type == 66) ? '100%' : '', textAlign: 'left'
                }">
                  <el-checkbox v-model="checkbox[childThree.name]" @change="permissionsChange($event, childThree, childTwo)" :style="{
                    width: childThree.item_type == 66 ? '100%' : '',
                  }" >{{ childThree.display_name }}</el-checkbox>
                  <div _flex="~ wrap" :class="[childThree.item_type == 66 && 'border-left-half']">
                    <div v-for="childFour in childThree?.children" :key="childFour?.id">
                      <el-checkbox v-model="checkbox[childFour.name]" @change="permissionsChange($event, childFour, childThree)" :style="{
                        marginLeft: childThree.item_type == 66 ? '15px' : ''
                      }">{{ childFour.display_name }}</el-checkbox>
                      <div _flex="~ wrap" :class="[childFour.item_type == 66 && 'border-left-half']" _m="l-15px">
                        <div v-for="childFive in childFour?.children" :key="childFive?.id">
                          <el-checkbox v-model="checkbox[childFive.name]" @change="permissionsChange($event, childFive, childThree)" :style="{
                            marginLeft: childFive.item_type == 99 ? '15px' : ''
                          }">{{ childFive.display_name }}</el-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    data: Array,
    permissions: {
      default: () => [],
      type: Array
    },
    type: String,
    visible: Boolean
  },
  data() {
    return {
      cellHeight: {},
      isIndeterminate: {},
      checkbox: [],
      initialize: false // 初始化不用走勾选逻辑，直接赋值
    }
  },
  watch: {
    visible: {
      handler(bbb) {
        this.checkbox = this.flattenTree(this.data)
        this.initialize = false
        if ((this.type == '编辑角色' || this.type == '查看角色') && this.permissions?.length > 0) {
          this.initialize = true
          this.permissions.forEach(el => {
            this.checkbox[el.name] = true
          })
          setTimeout(() => {
            this.initialize = false
          }, 100);
        }
      },
      immediate: true
    },
    // type: {
    //   handler(aaa) {
    //     this.checkbox = this.flattenTree(this.data)
    //     this.initialize = false
    //     if (aaa == '编辑角色' && this.permissions?.length > 0) {
    //       this.initialize = true
    //       this.permissions.forEach(el => {
    //         this.checkbox[el.name] = true
    //       })
    //       setTimeout(() => {
    //         this.initialize = false
    //       }, 100);
    //     }
    //   },
    //   immediate: true
    // }
  },
  methods: {
    permissionsChange(e, can, parent) {
      if (this.type == '查看角色') return
      if (this.initialize) {
        this.$set(this.checkbox, can.name, e)
      } else {
        // 勾选父级子级也需要自动勾选
        const data = this.changeAll(can)
        data.forEach(el => {
          this.$set(this.checkbox, el, e)
        })
        // this.$set(this.checkbox, can.name, e)
        // 勾选子级需要自动勾选父级
        if (can.pid != 0) {
          const parent = this.findParentsOfId(this.data, can.pid)
          parent.forEach(el => {
            this.$set(this.checkbox, el.name, true)
          })
        }
      }
      console.log(e, can, this.checkbox, '分类')
    },
    adjustHeight() {
      this.cellHeight = []
      const els = document.querySelectorAll('.all')
      els.forEach(el => {
        const height = el.offsetHeight
        this.cellHeight[el.getAttribute('data-idx')] = height
      })
      console.log(this.cellHeight, 'cellHeight')
    },
    flattenTree(tree) {
      const result = {}
      function traverse(nodes) {
        for (const node of nodes) {
          result[node.name] = false
          if (node.children && node.children.length > 0) {
            traverse(node.children);
          }
        }
      }
      traverse(tree);
      return result;
    },
    // 勾选父级子级也需要自动勾选
    changeAll(node) {
      const names = [node.name];
      function traverse(children) {
        for (const child of children) {
          names.push(child.name);
          if (child.children && child.children.length > 0) {
            traverse(child.children);
          }
        }
      }
      if (node.children && node.children.length > 0) {
        traverse(node.children);
      }
      return names;
    },
    // 勾选子级需要自动勾选父级
    findParentsOfId(data, id) {
      function findNodeById(nodes, targetId) {
        for (const node of nodes) {
          if (node.id === targetId) {
            return [node];
          }
          if (node.children) {
            const child = findNodeById(node.children, targetId);
            if (child.length > 0) {
              return [node].concat(child);
            }
          }
        }
        return [];
      }
      return findNodeById(data, id);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.adjustHeight()
    })
  }
}
</script>
<style lang="scss" scoped>
.flex{
  display: flex;
}
/deep/ .cell {
  padding: 0 !important;
  line-height: 40px !important;
}
/deep/ .el-table__cell {
  padding: 0 !important;
}
.nowrap {
  white-space: nowrap;
}
.last-bottom-none > *:last-child {
  border-bottom: none !important;
}
.border-bottom {
  border-bottom: 1px solid #ebeef5;
}
.border-left-all {
  border-left: 1px solid #CBCBCB;
}
.border-left-half {
  position: relative;
}
.border-left-half::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 89%;
  background-color: #CBCBCB;
  transform: translateY(-50%);
}
</style>

<style>
.highlight-column {
  background-color: #FFF7F4 !important;
}
</style>
